import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import SubUserAdd from './SubUserAdd.js';
import { addSubUserAction, SubUserListAction, SubUserStatusAction } from '../../actions/Subuser';
import loadingImage from "../loadingImageRc.gif";
import Auth from '../Auth/auth';

const auth = new Auth();
let className = "";
class SubUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            count: 0,
            currentPage: 1,
            sizePerPage: 10,
            requestServer: true,
            detailsModal: false,
            editModal: false,
            addSubUserModal: false,
            jobDetails: {},
            editJobs: {}
        };
        this.editDetails = this.editDetails.bind(this)
        this.addSubUser = this.addSubUser.bind(this)
    }

    componentWillMount() {
        let reqObj = {
            "limit": 10,
            "offset": 0,
            "order": "createdAt",
            "direction": "desc",
            "search": "",
            "status": ""
        }
        //this.profile();
        this.props.SubUserListAction(reqObj);
    }

    jobListGet = (sizePerPage, page) => {
        let reqObj = {
            "limit": sizePerPage,
            "offset": (page === 0 ? page : page - 1),
            "order": "createdAt",
            "direction": "desc",
            "search": "",
            "status": ""
        }
        //this.profile();
        this.props.SubUserListAction(reqObj);
    }

    componentWillReceiveProps(nextProps) {
        switch (nextProps.responseType) {
            case "List":
                this.setState({
                    requestServer: false,
                    list: nextProps.response.data && nextProps.response.data.data,
                    count: nextProps.response.data && nextProps.response.data.count,
                })
                break;
            case "add":
                let _this = this;
                this.setState({
                    requestServer: false,
                    addSubUserModal: !this.state.addSubUserModal
                })
                this.jobListGet(this.state.sizePerPage, this.state.page);
                break;
            case "update":
                this.setState({
                    editJobs: {},
                    requestServer: false,
                    editModal: false
                })
                this.jobListGet(this.state.sizePerPage, this.state.page);
                break;
            default:
                return true;
        }
    }

    addSubUser = () => {
        this.setState({
            addSubUserModal: !this.state.addSubUserModal
        })
    }

    viewJobs = (data) => {
        this.setState({
            jobDetails: data,
            detailsModal: !this.state.detailsModal
        })
    }

    viewDetails = () => {
        this.setState({
            jobDetails: {},
            detailsModal: !this.state.detailsModal
        })
    }

    editDetails = () => {
        this.setState({
            editModal: !this.state.editModal
        })
    }

    sizePerPageListChange(sizePerPage) {
        this.setState({
            sizePerPage: sizePerPage
        })
        this.jobListGet(sizePerPage, this.state.currentPage);
    }

    chnageStatus = (data, type, value) => {
        let reqObj = {
            id: data._id
        }
        if (data.status === "active") {
            reqObj.status = "inactive"
        } else {
            reqObj.status = "active"
        }
        this.setState({
            statusChange: true
        })
        this.props.SubUserStatusAction(reqObj)
    }

    onPageChange(page, sizePerPage) {
        this.setState({
            currentPage: page,
            sizePerPage: sizePerPage
        })
        this.jobListGet(sizePerPage, (page));
    }

    jobActionList(cell, row, rowIndex) {
        if (row && row.status) {
            //let fileUrl = process.env.REACT_APP_SERVER_IMAGE_BUCKET + "/" + row.resumeImage;
            return <div>&nbsp;
                <button className="buttons1" onClick={this.chnageStatus.bind(this,row,"status")}>{row.status}</button>
            </div>
        } else {
            return <span>-</span>
        }
    }

    onGetProjectSEDate(cell, row, rowIndex) {
        if (row && row.createdAt) {
            return (this.props.auth.formatDate(row.createdAt))
        } else {
            return <span>-</span>
        }
    }

    render() {
        const { sizePerPage, list, count, requestServer } = this.state;
        var options = {
            onPageChange: this.onPageChange.bind(this),
            page: this.state.currentPage,
            onSizePerPageList: this.sizePerPageListChange.bind(this),
            sizePerPage: sizePerPage,
            paginationPosition: 'bottom',
            alwaysShowAllBtns: true,
            prePage: 'Prev',
            nextPage: 'Next',
            firstPage: 'First',
            lastPage: 'Last',
        };
        if (requestServer) {
            className = "pageloading";
        } else {
            className = "";
        }
        return (
            <div className="">
                <div className={"pageForLoading "+className}>
                    <div className=" wrap">
                        <div className="loading">
                            <img src={loadingImage} alt="Loading" />
                        </div>
                    </div>
                </div>
                <div className="history-block">
                    <h3 className="ac-head">Recruiter</h3>
                    <button className="ac-head" onClick={this.addSubUser}> Add Recruiter</button>
                    <div className="resume-history">
                        <div className="status-content">
                            <div className="status-content">
                                <BootstrapTable data={list} options={options } remote={true} fetchInfo={ { dataTotalSize: count } } pagination>
                                    <TableHeaderColumn hidden={true} dataField='_id' isKey>object ID</TableHeaderColumn>
                                    <TableHeaderColumn width='200' tdAttr={{'data-attr':'Name' }} dataField='firstName'>Name</TableHeaderColumn>
                                    <TableHeaderColumn width='200' tdAttr={{'data-attr':'Email' }} dataField='email'>Email</TableHeaderColumn>
                                    <TableHeaderColumn width='200' tdAttr={{'data-attr':'Date' }} dataField='' dataFormat={this.onGetProjectSEDate.bind(this)}>Date</TableHeaderColumn>
                                    {/*<TableHeaderColumn width='150' tdAttr={{'data-attr':'Status' }} dataField='status'>Status</TableHeaderColumn>*/}
                                    <TableHeaderColumn tdAttr={{'data-attr':'Action' }} dataField='' dataFormat={this.jobActionList.bind(this)}>Action</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        </div>
                    </div>
                    <SubUserAdd auth={auth} isOpen={this.state.addSubUserModal} action={this.addSubUser} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        responseType: state.SubUser.type,
        response: state.SubUser.response,
    };
}

export default withRouter(connect(mapStateToProps, {
    addSubUserAction,
    SubUserListAction,
    SubUserStatusAction
})(SubUser));


// WEBPACK FOOTER //
// ./src/components/SubUser/SubUser.js